import { createAction, props } from '@ngrx/store';
import { Encounter, Diagnosis } from '@mona/models';
import { AsyncAction, SucceededAction, FailedAction } from '@mona/store';

/**
 * Diagnoses actions
 */
export class DiagnosesAction {
    /**
     * Load diagnoses action
     */
    static loadDiagnosesAction: AsyncAction<
        {
            encounterId: EntityId<Encounter>;
        },
        Diagnosis[]
    > = {
        action: createAction(
            'ENCOUNTER:LOAD_DIAGNOSES',
            props<{
                encounterId: EntityId<Encounter>;
            }>(),
        ),

        succeededAction: createAction('ENCOUNTER:LOAD_DIAGNOSES_SUCCEEDED', props<SucceededAction<Diagnosis[]>>()),

        failedAction: createAction('ENCOUNTER:LOAD_DIAGNOSES_FAILED', props<FailedAction>()),

        clearAction: createAction('ENCOUNTER:LOAD_DIAGNOSES_CLEAR'),
    };
}
